import axios, { AxiosInstance } from "axios";

export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const REDIRECT_URL = process.env.REACT_APP_REDIRECT_URL;

export const getAccesToken = () => {
  return localStorage.getItem("accesToken");
};

const errorInterceptor = (val: AxiosInstance) => {
  val.interceptors.response.use(
    (res) => {
      return res;
    },
    (err) => {
      if (err.response.status === 401 || err.response.status === 403) {
        localStorage.removeItem("accesToken");
        window.location.reload();
      } else {
        return Promise.reject(err);
      }
    }
  );
};

export const authorise = () => {
  return {
    headers: {
      Authorization: `Bearer ${getAccesToken()}`,
    },
  };
};

export const apiClient = axios.create({
  baseURL: BASE_URL,
});

errorInterceptor(apiClient);
